import script from "./payroll-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-settings.vue?vue&type=script&setup=true&lang=js"

import "./payroll-settings.vue?vue&type=style&index=0&id=4cab1a32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cab1a32"]])

export default __exports__